<template>
  <div class="after_add_to_cart_modal">
    <GenericModal
      unique-id="afterAddToCartModal"
      ref="afterAddToCartModal"
      :has-header="true"
      :has-footer="true"
      :max-width="'1370px'"
      :max-height="'500px'"
      :display="'block'"
      :overflow="'hidden'"
      :close-btn-color="'#CEAB59'"
      :close-btn-position="'in'"
      :exit-modal-icon-font-size="'18px'"
      backgroundBlur="none"
      border-radius="25px"
      :border="'2px solid #C4AB7B'"
      @modal-closed="modalClosed()"
      @modal-opened="setAfterAddToCartRecommendationRequest(false)"
    >
      <template
        v-slot:header
      >
        <div class="prod_cart_modal_hdr">
          <div class="container-fluid">
            <div class="cart_mod_header_actions mobile">
              <a href="/order/cart" class="d-flex justify-content-center align-items-center cart_mod_header_actions_cart">
                {{ t('after.add.to.cart.modal.actions.cart') }}
              </a>
              <a href="/preview_order" class="d-flex justify-content-center align-items-center cart_mod_header_actions_checkout">
                {{ t('after.add.to.cart.modal.actions.checkout') }}
              </a>
            </div>
            <div class="row">
              <div class="col-12 after_add_to_cart_header_title">
                {{ t('after.add.to.cart.modal.header.title') }}
              </div>
              <div class="col-12 after_add_to_cart_header_description">
                <span>{{ t('after.add.to.cart.modal.header.description') }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="prod_cart_modal_slider_wrap">
        <div class="native_slider">
          <button class="native_slider-btn native_slider-btn-prev_rd" data-always_show="1" data-scroll_left_by="-1" aria-label="Previous">Prev</button>
          <div class="native_slider-lg" data-drag_speed="2">
            <div v-for="(product, Idx) in liveData" :key="Idx" class="native_slider-li">
              <div class="modal_p_card">
                <div class="m_card_in">
                  <div class="m_card_thumb_wrap">
                    <div class="thumbnail_container">
                      <div class="thumbnail product-page-single-img">
                        <a :href="productUrl(product)" :title="product.name">
                          <img
                            :alt="product.name"
                            :src="productMainImage(product)"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="modal_p_card_main">
                    <div class="modal_p_card_title">
                      <a :href="productUrl(product)" :title="product.name">
                        {{ product.name.length > 70 ? product.name.substring(0, 70) + '...' : product.name }}
                      </a>
                    </div>
                    <div v-if="product.productHasDiscount" class="row no-gutters w-100">
                      <div class="col-6 justify-content-end flex-column d-none">
                        <span class="modal_p_card_price_text">{{ t('product.price.label') }} </span>
                        <span class="modal_p_card_price_col og_price">
                          {{ (product.productOldPrice * getSelectedCurrency.rate).toFixed(2) }}
                          <span v-html="getSelectedCurrency.symbol"></span>
                        </span>
                      </div>
                      <div class="col-6 d-flex justify-content-end flex-column price_final_right">
                        <span class="modal_p_card_price_text final_price_label">{{
                            t('product.price.label.heals')
                          }} </span>
                        <span class="modal_p_card_price_col price_final">
                          {{ (product.productFinalPrice * getSelectedCurrency.rate).toFixed(2) }}
                          <span v-html="getSelectedCurrency.symbol"></span>
                        </span>
                      </div>
                    </div>
                    <div v-else class="row no-gutters w-100">
                      <span class="col-6 offset-6 d-flex justify-content-end flex-column price_final_right">
                      <span class="modal_p_card_price_text final_price_label">{{t('product.price.label.heals') }} </span>
                        <span class="modal_p_card_price_col price_final">
                          {{ (product.productFinalPrice * getSelectedCurrency.rate).toFixed(2) }}
                          <span v-html="getSelectedCurrency.symbol"></span>
                        </span>
                      </span>
                    </div>
                    <div class="modal_p_card_add pt-2">
                      <AdvCardButtonViewBuyPicker
                        :show-quick-view="false"
                        :product-id="Number(product.product_id)"
                        :product-code-id="product.productCodeId"
                        :is-listing="true"
                        :is-variation-group-master="false"
                        :recommendation-id="product.recommendationId"
                        :recommendation-type="product.recommendationType"
                      >
                      </AdvCardButtonViewBuyPicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="native_slider-btn native_slider-btn-next_rd" data-always_show="1" data-scroll_left_by="1" aria-label="Next">Next</button>
        </div>
      </div>
      <template v-slot:footer>
        <div class="cart_mod_header_actions desktop">
          <a href="/order/cart" class="d-flex justify-content-center align-items-center cart_mod_header_actions_cart">
            {{ t('after.add.to.cart.modal.actions.cart') }}
          </a>
          <a href="/preview_order" class="d-flex justify-content-center align-items-center cart_mod_header_actions_checkout">
            {{ t('after.add.to.cart.modal.actions.checkout') }}
          </a>
        </div>
      </template>
    </GenericModal>
  </div>
</template>

<script>

import GenericModal from './presentation/GenericModal'
// import AdvButtonViewBuy from './AdvButtonViewBuy.vue'
// import AdvProductCard from './AdvProductCard.vue'
import AdvCardButtonViewBuyPicker from './AdvCardButtonViewBuyPicker.vue'
import { mapActions, mapGetters } from 'vuex'
import firstMainProductImage from '../../vue/mixins/firstMainProductImage'

export default {
  name: 'AfterAddToCartModal',
  mixins: [firstMainProductImage],
  components: {
    GenericModal,
    // AdvButtonViewBuy,
    // AdvProductCard,
    AdvCardButtonViewBuyPicker
  },
  watch: {
    afterAddToCartRecommendationOpenModal: function (newValue, oldValue) {
      if (newValue === false) {
        this.$refs.afterAddToCartModal.closeModal()
      }
    },
    liveData: {
      handler (value) {
        if (!value.length || this.modalIsOpen || !this.afterAddToCartRecommendationOpenModal) return
        this.$refs.afterAddToCartModal.openModal()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedCurrency',
      'getProductById',
      'afterAddToCartRecommendationProducts',
      'afterAddToCartRecommendationOpenModal'
    ]),
    modalIsOpen () {
      return this.$refs.afterAddToCartModal.isModalCurrentlyOpen
    },
    liveData () {
      const recommendations = this.afterAddToCartRecommendationProducts
      if (!recommendations) return []
      return recommendations.map((product) => {
        const productData = this.getProductById(Number(product.product_id))
        if (!productData) return null
        const productCodeId = productData?.productCode?.id ||
          (Array.isArray(productData.productCodes) && productData.productCodes.length > 0
            ? productData.productCodes[0]?.productCodeId || null
            : null)
        return {
          ...productData,
          ...product,
          productCodeId
        }
      }).filter((product) => product)
    }
  },
  methods: {
    ...mapActions([
      'setAfterAddToCartRecommendationRequest',
      'setAfterAddToCartRecommendationModal'
    ]),
    modalClosed () {
      this.setAfterAddToCartRecommendationModal(false)
      this.setAfterAddToCartRecommendationRequest(true)
    },
    productMainImage (product) {
      try {
        return this.firstMainProductImage(product).small
      } catch (e) {
        return '/ui/main/img/no_photo.jpg'
      }
    },
    buildQueryString (product) {
      if (product.recommendationType && product.recommendationId) {
        const urlParams = {}
        urlParams[window.advAppContext.advAppData.url.recommendationTypeQuerystring] = product.recommendationType
        urlParams[window.advAppContext.advAppData.url.recommendationIdQuerystring] = product.recommendationId
        return '?' + new URLSearchParams(urlParams).toString()
      }

      return ''
    },
    productUrl (product) {
      const queryString = this.buildQueryString(product)
      return product.productUrl + queryString
    }
  }
}
</script>

<style lang="scss" scoped>
.native_slider-lg {
  grid-auto-columns: calc((100% - 100px) / 3);
  gap: 50px;
  @media screen and (min-width: 992px) and (max-width: 1340px) {
    grid-auto-columns: 40%
  }
  @media screen and (min-width: 870px) and (max-width: 991px) {
    grid-auto-columns: calc(50% - 30px)
  }
  @media screen and (min-width: 651px) and (max-width: 869px) {
    grid-auto-columns: 65%
  }
  @media screen and (min-width: 585px) and (max-width: 650px) {
    grid-auto-columns: 70%
  }
  @media screen and (min-width: 575px) and (max-width: 584px) {
    grid-auto-columns: 100%;
    gap: 0;
  }
  @media screen and (max-width: 575px) {
    grid-template-columns: 100%;
    grid-auto-columns: 100%;
    grid-template-rows: repeat(4, 1fr);
    grid-column-gap: 0;
    grid-row-gap: 15px;
    grid-auto-flow: row
  }
}

.native_slider-btn {
  top: 30%;
  right: 0;
  transform: translateY(-30%);
  &-next_rd {
    right: 0;
  }
  &-prev_rd {
    left: 0
  }
  @media screen and (max-width: 575px) {
    display: none !important
  }
}

.prod_cart_modal_hdr {
  .after_add_to_cart_header_title {
    font-size: 30px;
    font-weight: 800;
    color: #252525;
  }

  .after_add_to_cart_header_description {
    padding-top: 10px;
    font-size: 15px;
    color: #C4AB7B;
  }

  @media screen and (max-width: 767px) {
    .after_add_to_cart_header_title {
      font-size: 26px;
    }
    .after_add_to_cart_header_description {
      font-size: 14px;
    }
  }
  @media screen and (max-width: 475px) {
    .after_add_to_cart_header_title {
      font-size: 19px;
    }
    .after_add_to_cart_header_description {
      font-size: 10px;
    }
  }
}

.cart_mod_header {
  &_actions {
    display: flex;
    justify-content: center;

    &.desktop {
      @media screen and (max-width: 575px) {
        display: none;
      }
    }

    &.mobile {
      display: grid;
      grid-template-columns: auto auto;
      justify-content: space-evenly;
      padding-bottom: 1rem;
      width: 90%;
      margin: 0 auto;
      @media screen and (min-width: 576px) {
        display: none;
      }
      @media screen and (max-width: 576px) {
        gap: 5px;
        width: 100%;
      }
    }

    &_cart {
      font-size: clamp(0.875rem, 1.5vw, 1rem);
      color: #fff;
      font-weight: 600;
      margin: 0 15px;
      background: #262626 0% 0% no-repeat padding-box;
      padding: 12px 20px;
      @media screen and (max-width: 576px) {
        margin: 0;
      }
    }

    &_checkout {
      font-size: clamp(0.875rem, 1.5vw, 1rem);
      color: #fff;
      font-weight: 600;
      margin: 0 15px;
      background: #C4AB7B 0% 0% no-repeat padding-box;
      padding: 5px 10px;
      @media screen and (max-width: 576px) {
        margin: 0;
      }
    }
  }
}

.modal_p_card_main {
  height: 100%;

  .modal_p_card_price_text {
    display: block;
    font-size: 12px;
  }

  .final_price_label {
    font-weight: 700;
  }
}

@media screen and (min-width: 576px) {
  .modal_p_card_add.mobile {
    display: none !important;
  }
}

@media screen and (max-width: 575px) {
  .modal_p_card {
    padding: 0 25px !important;
  }
  .modal_p_card_add.desktop {
    display: none !important;
  }
  .modal_p_card_price_text {
    display: none !important;
  }
  .price_final_right {
    align-items: end;
    display: block!important;
  }
  .modal_p_card_price_col {
    &.og_price {
      font-size: 15px;
    }

    &.price_final {
      font-size: 25px;
    }
  }
}
</style>
